import React from 'react';
import { translate } from 'react-i18next';
import Actions from 'inpc/components/list/InpcActions';

import { formatNumber } from 'accounting-js';

const InpcListRow = ({ inpc, company, permissions, t, handleToggle }) => {
  return (
    <tr>
      <td className="text-center">{inpc.year}</td>
      <td className="text-right">{formatNumber(inpc.values['1'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['2'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['3'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['4'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['5'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['6'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['7'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['8'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['9'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['10'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['11'], { precision: 4 })}</td>
      <td className="text-right">{formatNumber(inpc.values['12'], { precision: 4 })}</td>
      <td className="text-center">
        <Actions
          permissions={permissions}
          inpc={inpc}
          company={company}
          handleToggle={handleToggle}
        />
      </td>
    </tr>
  );
};

export default translate()(InpcListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/list/InpcListRow.js